"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        border: 0,
        color: 'black',
        height: '100%',
        padding: 0,
        paddingLeft: '1%',
        width: '100%',
    },
});
var DocumentPageTextInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var id = input.id, status = input.status, value = input.value;
    var isDisabled = status === types_1.PageInputStatus.Disabled;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    var className = statusClass + " " + classes.root;
    return isDisabled ? (react_1.default.createElement("div", { className: className }, value !== null && value !== void 0 ? value : '')) : (react_1.default.createElement("input", { type: "text", className: className, "data-tid": "DocumentPageTextInput-input-" + id, onChange: function (e) { return onChange(e.target.value); }, onFocus: function () { return onFocus(); }, value: value !== null && value !== void 0 ? value : '' }));
};
exports.default = DocumentPageTextInput;
//# sourceMappingURL=DocumentPageTextInput.js.map